const PAGE_SUGGESTIONS: Record<string, string[]> = {
  autoscaleRules: [
    'What is an autoscaling rule?',
    'How do I create a new rule?',
    'What are Conditions, and how do I add one?',
    'What do the Volumes, Capacity, and Utilization columns show me?',
    'When is a volume listed under Exceptions?',
  ],
  allVolumes: [
    'What does the AutoScale toggle do?',
    "What's the difference between Current Size and Original Size?",
    'Why is the AutoScale toggle disabled for some volumes?',
    'How can I find a specific volume?',
  ],
  volumeDetail: [
    'How do I turn AutoScaling on or off for this volume?',
    'What are the Datafy Volumes listed here?',
    'How do I read the Usage and Utilization charts?',
    'What do the Grow and Shrink entries in the Optimization Actions log mean?',
    "What's the difference between Current Size and Original Size?",
  ],
  reports: [
    'What does "full potential" represent on the savings card?',
    'Which volumes are shown in the Usage and Utilization charts?',
    'What do the Grow and Shrink entries in the Optimization Actions log mean?',
  ],
  settingsConfigurations: [
    'How do instance or cluster level configurations override the account configurations?',
    'What does each configuration field control?',
    'How do I revert unsaved changes?',
  ],
  settingsPermissions: [
    'What is the Role ARN used for?',
    'What AWS permissions does this role need?',
    'How do I know the role is correct?',
  ],
};

export const getAreaFromPath = (pathname: string): string =>
  pathname.split('/').filter(Boolean)[0] ?? 'other';

const VOLUME_ID_PATTERN = /^\/fleet-manager\/(?!autoscale-rules(?:\/|$)|all-volumes(?:\/|$))[^/]+(?:\/|$)/;

export const getSuggestionsForPath = (pathname: string): string[] => {
  if (pathname.startsWith('/fleet-manager/autoscale-rules')) {
    return PAGE_SUGGESTIONS.autoscaleRules;
  }

  if (pathname.startsWith('/fleet-manager/all-volumes')) {
    return PAGE_SUGGESTIONS.allVolumes;
  }

  if (VOLUME_ID_PATTERN.test(pathname)) {
    return PAGE_SUGGESTIONS.volumeDetail;
  }

  if (pathname.startsWith('/reports')) {
    return PAGE_SUGGESTIONS.reports;
  }

  if (pathname.startsWith('/settings/configurations')) {
    return PAGE_SUGGESTIONS.settingsConfigurations;
  }

  if (pathname.startsWith('/settings/permissions')) {
    return PAGE_SUGGESTIONS.settingsPermissions;
  }

  return [];
};
